import { action } from "satcheljs";
import type { InstrumentationContext } from "owa-search-types/lib/types/InstrumentationContext";
import type { TriageContext } from "./TriageContext";

// Currently only suppored in compose (i.e. without index)
// | 'MarkMessageAsImportant'
// | 'MarkMessageAsUnimportant'
// | 'MarkMessageAsNormal'

export type ActionType = "LinkClicked" | "Delete" | "Move" | "Flag" | "FlagComplete" | "FlagCleared" | "Categorize" | "MarkAsRead" | "MarkAsReadImplicit" | "MarkAsUnread" | "MarkAsJunk" | "Print" | "Reply" | "ReplyAll" | "Forward" | "OpenedAnAttachment" | "PreviewOfAttachmentStarted" | "ModernGroupsQuickReply" | "ModernGroupsConversationSelected" | "MarkAsNotSpam" | "Unsubscribe" | "ReportAndDelete" | "MarkAsPhishing" | "PopOut" | "ReadingPaneDisplayStart" | "ReadingPaneDisplayEnd" | "Pin" | "Unpin" | "Ignore" | "Reaction" | "Search" | "Snooze" | "Restore" | "Block" | "ReportAbuse" | "CreateRule" | "DeleteMeetingMessage";

export interface USERMAIL_INTERACTIONActionMessage {
    interactionType: ActionType;
    instrumentationContexts: InstrumentationContext[] | null;
    triageContext: TriageContext | undefined;
}
export const userMailInteractionAction: (interactionType: ActionType, instrumentationContexts: InstrumentationContext[] | null, triageContext?: TriageContext) => USERMAIL_INTERACTIONActionMessage = action("USERMAIL_INTERACTION", (interactionType: ActionType, instrumentationContexts: InstrumentationContext[] | null, triageContext?: TriageContext): USERMAIL_INTERACTIONActionMessage => {
    return {
        interactionType,
        instrumentationContexts,
        triageContext,
    };
});

export default function (interactionType: ActionType, instrumentationContexts: InstrumentationContext[] | null, triageContext?: TriageContext): void {
    if (instrumentationContexts && instrumentationContexts.length > 0) {
        userMailInteractionAction(interactionType, instrumentationContexts, triageContext);
    }
}
